/** Copyright (c) 2017 T. Rowe Price. All rights reserved. */

import './BalanceBar.scss';

import isEmpty from 'lodash/isEmpty';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import CustomerInfo from 'components/layouts/Bar/Balance/Customer/CustomerInfo';

import { privateAssetManagementUrl } from 'services/Externals';

import {
  getAccountBalances,
  getTotalWithRpsBalances,
  getTotalDailyChangeWithRpsBalances,
  getTotalDailyRateWithRpsBalances,
  getYearToDateAmount,
  getYearToDateRate
} from 'state/account/AccountBalancesSelectors';
import {
  hasAlaska529Only,
  getView,
  hasNational529Only,
  getCanViewYTDChange
} from 'state/view/ViewSelectors';

import { BalanceBarPortfolioDailyYearlyContainer } from './BalanceBar';
import { BalanceBarLoadingSkeleton } from 'components/layouts/LoadingSkeleton/LoadingSkeleton';
import { getAssetId } from 'state/household/HouseholdInformationSelectors';
import {
  PREFERRED,
  summitMembershipMapById
} from 'services/HouseholdInformationCard';
import {
  getAccountChangeAccounts,
  getHasOwnedCollegeSavingsOnly,
  getHasRetailTracAccounts,
  getHasWorkPlaceRetirementAccounts
} from 'state/account/AccountSelectors';
import AsOfDate from './AsOfDate';
import { withOtelContext } from '@trp-ta-nitro/otel-react';
import { getPortfolioAsOfDate } from 'state/portfolio/PortfolioSelectors';
import { AAMBeaconButton } from 'components/shared/Beacon'
import { ReactComponent as OpenNewtab } from 'assets/open-tab.svg';


const StandardBalanceBar = ({
  balances,
  canViewYTDChange,
  customer,
  clientTierId,
  hasAlaska529Only,
  hasNational529Only,
  hasCollegeSavingsOnly,
  hasPendingTransactions,
  is529Only,
  isPAM,
  isReturningPAM,
  otelContext,
  rpsBalances,
  isMobileLayout,
  totalPortfolio,
  totalDailyChange,
  totalDailyRate,
  yearlyChange,
  yearlyRate,
  accountChangeAccounts,
  asOfDate,
  isBalanceBarDataLoading,
  hasRetailTracAccounts,
  hasWorkplaceAccounts
}) => {
  const isLoading = isBalanceBarDataLoading;
  const hasWprAccounts = !isEmpty(rpsBalances.accounts);
  const clientTier =
    clientTierId !== PREFERRED && summitMembershipMapById[clientTierId];

  return (
    <Fragment>
      {isLoading && <BalanceBarLoadingSkeleton isActive={isLoading} />}
      {!isLoading && (
        <div className="beacon-on-dark balance-bar-container">
          <div className="balance-bar">
            {isPAM && isReturningPAM &&
              <div style={{ marginTop: '4px', textAlign: 'right' }}>
                <AAMBeaconButton
                  variant="tertiary"
                  scale="mini"
                  link-href={privateAssetManagementUrl}
                  link-target="_blank"
                >
                  Private Asset Management
                  <OpenNewtab slot={'prefix'} />
                </AAMBeaconButton>
              </div>
            }

            <div className="balance-bar-header customer">
              <CustomerInfo
                customer={customer}
                isMobileLayout={isMobileLayout}
                clientTier={clientTier}
                hideServiceLevel={hasCollegeSavingsOnly !== false}
              />
              <BalanceBarPortfolioDailyYearlyContainer
                addAccountBalanceClass=""
                canViewYTDChange={canViewYTDChange}
                hasWprAccounts={hasWprAccounts}
                balances={balances}
                is529Only={is529Only}
                hasAlaska529Only={hasAlaska529Only}
                hasNational529Only={hasNational529Only}
                otelContext={otelContext}
                totalPortfolio={totalPortfolio}
                totalDailyChange={totalDailyChange}
                totalDailyRate={totalDailyRate}
                yearlyChange={yearlyChange}
                yearlyRate={yearlyRate}
                accountChangeAccounts={accountChangeAccounts}
                asOfDate={asOfDate}
              />
            </div>
            <AsOfDate
              asOfDate={asOfDate}
              hasPendingTransactions={hasPendingTransactions}
              hasWprAccounts={hasWprAccounts}
              is529Only={is529Only}
              hasRetailTracAccounts={hasRetailTracAccounts}
              hasWorkplaceAccounts={hasWorkplaceAccounts}
            />
          </div>
        </div>
      )
      }
    </Fragment >
  );
};

StandardBalanceBar.defaultProps = {
  balances: {
    monthlyAvailable: false,
    yearlyAvailable: false
  },
  hasPendingTransactions: false,
  rpsBalances: {
    accounts: []
  }
};

const mapStateToProps = (state) => {
  return {
    balances: getAccountBalances(state),
    customer: state.customer,
    clientTierId: getAssetId(state),
    hasNational529Only: hasNational529Only(state),
    hasAlaska529Only: hasAlaska529Only(state),
    hasCollegeSavingsOnly: state.view.hasCollegeSavingsOnly,
    hasPendingTransactions: state.view.hasPendingTransactions,
    is529Only: getHasOwnedCollegeSavingsOnly(state),
    isPAM: state.view.isPAM,
    isReturningPAM: state.view.isReturningPAM,
    rpsBalances: state.rpsBalances,
    isMobileLayout: state.view.isMobileLayout,
    view: getView(state),
    totalPortfolio: getTotalWithRpsBalances(state),
    yearlyChange: getYearToDateAmount(state),
    yearlyRate: getYearToDateRate(state),
    totalDailyChange: getTotalDailyChangeWithRpsBalances(state),
    totalDailyRate: getTotalDailyRateWithRpsBalances(state),
    canViewYTDChange: getCanViewYTDChange(state),
    accountChangeAccounts: getAccountChangeAccounts(state),
    asOfDate: getPortfolioAsOfDate(state),
    hasRetailTracAccounts: getHasRetailTracAccounts(state),
    hasWorkplaceAccounts: getHasWorkPlaceRetirementAccounts(state),
  };
};

export default compose(
  withRouter,
  withOtelContext,
  connect(mapStateToProps)
)(StandardBalanceBar);
